import { ModalFormStatus } from '../contracts/modal-form-status';
import { IAction } from './action';

export class SetStatus implements IAction {
    constructor(public status: ModalFormStatus) {}
}
